import type { NewsletterParams } from "../newsletter";

export const COURSES_BASE_URL =
  "https://api.infograficos.gazetadopovo.com.br/v3/courses";

/** Objeto de aula retornado por `summary` e `content`. */
export interface Course {
  curso: string;
  turma: string;
  "aula-id": string;
  titulo: string;
  descricao: string;
  /** `null` em `summary`; em `content`, `null` quando a aula ainda não foi liberada. */
  "url-video": string | null;
  /** Data de liberação no formato `DD/MM/YYYY`. */
  liberado: string;
  /** `DD/MM`. */
  date_verbose?: string | null;
  thumbnail: string | null;
}

/** Envelope padrão de `summary` e `content`. */
export interface CourseListResponse {
  data: Course[];
  success: true;
}

export interface SigninParams {
  email: string;
  className: string;
  courseName: string;
}

export interface SigninResult {
  /** `true` quando o e-mail já está matriculado na turma/curso. */
  enrolled: boolean;
  /** JWT de acesso — presente quando `enrolled` é `true`. */
  token?: string;
}

export interface SignupParams {
  email: string;
  className: string;
  courseName: string;
  /** Token anti-bot: reCAPTCHA v3 ou JWT assinado. Obrigatório (exceto no ambiente local da API). */
  token: string;
  newsletter?: NewsletterParams;
}

export interface SignupResult {
  signup: boolean;
  /** `true` se o usuário **já estava** matriculado antes desta chamada. */
  hasRegister: boolean;
  /** JWT de acesso. */
  token?: string;
  /** Resposta bruta da sincronização com o SalesForce. */
  salesforce?: unknown;
}

export interface SummaryParams {
  className: string;
  courseName: string;
}

export interface ContentParams {
  /** JWT de acesso emitido no `signin`/`signup`. */
  key: string;
}

/**
 * Erro de runtime da API de cursos. Lançado em falhas reais
 * (HTTP 4xx/5xx inesperados, rede). `status` é `0` em erro de rede.
 */
export class CoursesApiError extends Error {
  status: number;
  body?: unknown;

  constructor(message: string, status: number, body?: unknown) {
    super(message);
    this.name = "CoursesApiError";
    this.status = status;
    this.body = body;
  }
}
